import { useEffect } from 'react';

import { useErrorFallback } from './useErrorFallback';

export const ErrorFallback = () => {
  const redirectToError = useErrorFallback();

  useEffect(() => {
    redirectToError({ replace: true });
  }, [redirectToError]);

  return null;
};
